export type Feature = {
    image: string,
    title: string,
    description: string
};